import * as React from 'react'
function SvgGauge(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.2 30.677H35l.4-1.38c.4-1.379.6-2.955.6-4.532C36 16.095 28.8 9 20 9S4 16.094 4 24.765c0 1.577.2 2.956.6 4.533l.6 1.38zm15-17.736c6.6 0 12 5.321 12 11.824 0 .592 0 1.38-.2 1.971H21.6l-2.837-6.832a1.947 1.947 0 00-2.595-1.037l.064-.027c-1.012.443-1.5 1.643-1.096 2.666l2.064 5.23H8.4c-.2-.591-.2-1.38-.2-1.97 0-6.504 5.4-11.825 12-11.825z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgGauge
